var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('modify-wrapper', {
    attrs: {
      "isLogin": ""
    }
  }, [_c('div', {
    staticClass: "join-intro join-intro mb-40 mb-md-30"
  }, [_c('h2', {
    staticClass: "text-22 text-md-20 mb-10 mb-md-5"
  }, [_vm._v("전자제조지원단")]), _c('p', {
    staticClass: "text-16 text-md-14 color-gray-7e mb-20 mb-md-10"
  }, [_vm._v(" * 전자산업계는 용산의 혁신제품제조를 위해 자문, 교육을 지원하는 전문가 POOL을 지원하기로 함"), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("(‘19.10 전자60주년 협약, ’21.10 전자혁신제조 상생협력 협약) ")]), _c('p', {
    staticClass: "text-16 text-md-14 color-gray-7e mb-20 mb-md-10"
  }, [_c('strong', [_vm._v("(전문가)")]), _vm._v(" 전자IT제품 개발, 생산, 제조, 마케팅 분야에서 경험이 풍부한 전·현직 전문가 10명")]), _c('p', {
    staticClass: "text-16 text-md-14 color-gray-7e mb-20 mb-md-10"
  }, [_c('strong', [_vm._v("(역할)")]), _vm._v(" "), _c('u', [_vm._v("온라인"), _c('small', [_vm._v("(전자제조지원단사이트, 이메일 등)")]), _vm._v(" 문의에 대한 답변 또는 자문")]), _vm._v(", 필요 시 온라인 강의 또는 대면 회의 등 ")]), _c('p', {
    staticClass: "text-16 text-md-14 color-gray-7e mb-20 mb-md-10"
  }, [_vm._v(" * (자문) 전문분야 → 온라인 질의응답 (Daum Agora, Naver 지식iN과 유사)"), _c('br'), _vm._v(" ** (멘토링) 멘토선정 → 온라인 질의응답 (필요 시 온/오프라인 회의 ")]), _c('p', {
    staticClass: "text-16 text-md-14 color-gray-7e"
  }, [_c('strong', [_vm._v("(활동비)")]), _vm._v(" 자문료, 강의료, 멘토링비 지급")])]), _c('div', {
    staticClass: "login-container mt-0"
  }, [_c('div', {
    staticClass: "login-rowgroup"
  }, [_c('div', {
    staticClass: "login-row"
  }, [_c('v-text-field', {
    staticClass: "input",
    attrs: {
      "placeholder": "아이디",
      "type": "text",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs['pw'].focus();
      }
    },
    model: {
      value: _vm.username,
      callback: function callback($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  })], 1), _c('div', {
    staticClass: "login-row"
  }, [_c('v-text-field', {
    ref: "pw",
    staticClass: "input",
    attrs: {
      "placeholder": "비밀번호",
      "type": "password",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event);
      }
    },
    model: {
      value: _vm.password,
      callback: function callback($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c('div', {
    staticClass: "login-row login-row--links"
  }, [_c('label', {
    staticClass: "check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.remember,
      expression: "remember"
    }],
    staticClass: "input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.remember) ? _vm._i(_vm.remember, true) > -1 : _vm.remember
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.remember,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = true,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.remember = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.remember = $$c;
        }
      }
    }
  }), _c('i', {
    staticClass: "icon"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("아이디 저장")])]), _c('span', {
    staticStyle: {
      "width": "50px"
    }
  }), _c('ul', {
    staticClass: "links"
  }, [_c('li', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "/login/find-id/"
    }
  }, [_vm._v("아이디 찾기")])]), _c('li', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "/login/find-password/"
    }
  }, [_vm._v("비밀번호 찾기")])])])]), _c('div', {
    staticClass: "login-row login-row--submit"
  }, [_c('button', {
    staticClass: "button button--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_c('span', [_vm._v("로그인")])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }